export class SetModuleLoading {
  static readonly type = '[MODULELOAD] set module loading state';
  constructor(public payload: boolean) { }
}
